import React from "react"
import { Main, Arrow, Shadow, SpanBox } from "./style"
import SearchComponent from "../../SearchComponent"
import arrow from "../../../images/arrow.png"

const Header = () => {
  return (
    <Main>
      <Shadow />
      <Arrow src={arrow} alt="arrow" id="flats" />
      <SpanBox>
        <SearchComponent />
      </SpanBox>
    </Main>
  )
}

export default Header
